@if (selectedLayer && selectedIndicator) {
  <div class="p-card px-3 pt-1 pb-3">
    <div class="flex align-items-center gap-3">
      <app-header
        [text]="header"
        [icon]="
          activeIndicatorData?.published
            ? 'fas fa-earth-europe'
            : 'fas fa-house-user'
        "
        styleClass="text-primary"></app-header>
      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" />
      @if (canModify) {
        <p-button
          [rounded]="true"
          severity="secondary"
          class="ml-auto"
          [text]="true"
          (click)="menu.toggle($event)"
          icon="fas fa-ellipsis-vertical" />
      }
    </div>

    <div class="flex gap-3 p-card surface-ground align-items-center p-3 my-2">
      <app-type-dropdown
        [(selection)]="selectedLayerType"
        [globalSelector]="true"
        mode="all"></app-type-dropdown>
      @if (dataLayerStore.filterByParent(selectedLayer.parent); as dataLayers) {
        <app-year-list
          [dataLayers]="dataLayers"
          [asDropdown]="dataLayers.length > 3" />
      }
    </div>

    @if (districts) {
      <app-data-table
        [global]="true"
        [data]="activeIndicatorData"
        [districts]="districts"></app-data-table>
    }
    @if (!activeIndicatorData) {
      <app-alert
        styleClass="p-3 pt-1"
        header="Keine Daten gefunden"
        [canToggle]="false">
        @if (activeUserStore.canAccessEntityAdder()) {
          <div class="flex gap-3">
            <p-button
              label="Daten hinzufügen"
              icon="fas fa-circle-plus"
              [routerLink]="dataFormRouterLink"
              [rounded]="true"></p-button>
            <p-button
              label="Daten importieren"
              icon="fas fa-cloud-arrow-up"
              [routerLink]="[
                '/data-backend',
                {
                  outlets: {
                    overlay: ['cloud', { outlets: { panel: ['daten'] } }],
                  },
                },
              ]"
              [rounded]="true"></p-button>
          </div>
        }
      </app-alert>
    }
  </div>
} @else if (!selectedIndicator) {
  <app-alert
    styleClass="m-0 px-3 pt-1 pb-3"
    [canToggle]="false"
    header="Daten auswählen">
    Wählen Sie ein Jahr in einem Raum oder Standort aus, um die Daten zum
    ausgewählten Indikator anzuzeigen.
  </app-alert>
}
@if (selectedIndicator && selectedLayer && store.initialized()) {
  <p-sidebar
    (onHide)="onOverlayClose()"
    position="right"
    [modal]="false"
    [styleClass]="'w-8'"
    [visible]="editFormOverlay">
    <ng-template pTemplate="header">
      <app-header
        [icon]="editFormOverlayIcon"
        [text]="header || 'Daten'"></app-header
    ></ng-template>

    <ng-container *ngIf="editFormOverlay">
      <router-outlet name="bearbeiten"></router-outlet>
    </ng-container>
  </p-sidebar>
  <app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>

  @if (selectedLayerType) {
    <!--<app-confirm-publish-data
      *ngIf="activeIndicatorData"
      [dataLayerType]="selectedLayerType"
      [dataLayer]="selectedLayer"
      [indicator]="selectedIndicatorChild || selectedIndicator"
      [indicatorData]="activeIndicatorData"></app-confirm-publish-data>-->

    <app-confirm-lock-data
      *ngIf="activeIndicatorData"
      [dataLayerType]="selectedLayerType"
      [dataLayer]="selectedLayer"
      [indicator]="selectedIndicator"
      [indicatorData]="activeIndicatorData"></app-confirm-lock-data>
  }
}
